import React from 'react';

// Auf true setzen, wenn Vorher/Nachher-Karten mit Bildern angezeigt werden sollen
const SHOW_BEFORE_AFTER_ITEMS =false; 

const beforeAfterItems = [
  {
    id: 1,
    title: 'Gartenpflege',
    description: 'Beispiel für Rasen- und Heckenpflege.',
  },
  {
    id: 2,
    title: 'Außenanlagen',
    description: 'Beispiel für Wege, Einfahrten und Grünflächen.',
  },
  {
    id: 3,
    title: 'Reinigung',
    description: 'Beispiel für Treppenhaus und Gemeinschaftsflächen.',
  },
];

const BeforeAfter = () => {
  if (!SHOW_BEFORE_AFTER_ITEMS) {
    return null;
  }

  return (
    <section id="vorher-nachher" className="py-12 md:py-16 lg:py-24 bg-[#F5F7F2]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block text-[#FFD700] font-semibold text-xs sm:text-sm uppercase tracking-wider mb-2 sm:mb-4">
            Vorher & Nachher
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-[#1E4D2B] mb-4 sm:mb-6">
            Unsere Arbeiten im Vergleich
          </h2>
          <p className="text-[#2D5F3A] text-base sm:text-lg max-w-2xl mx-auto px-4 sm:px-0">
            Ersetzen Sie die Platzhalter später mit Ihren eigenen Vorher/Nachher-Bildern.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
          {beforeAfterItems.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-[32px] p-5 sm:p-6 shadow-sm border border-[#D4DCC9]/30"
            >
              <h3 className="text-lg sm:text-xl font-semibold text-[#1E4D2B] mb-1 sm:mb-2">
                {item.title}
              </h3>
              <p className="text-sm sm:text-base text-[#2D5F3A] mb-4 sm:mb-6 leading-relaxed">
                {item.description}
              </p>

              <div className="grid grid-cols-2 sm:grid-cols-2 gap-3 sm:gap-4">
                {['Vorher', 'Nachher'].map((label) => (
                  <div
                    key={label}
                    className="relative rounded-xl sm:rounded-2xl border-2 border-dashed border-[#C7D2C0] bg-[#EEF2EA] overflow-hidden"
                  >
                    <div className="absolute top-2 left-2 sm:top-3 sm:left-3 bg-white/80 text-[#1E4D2B] text-[10px] sm:text-xs font-semibold px-2 py-0.5 sm:px-3 sm:py-1 rounded-full">
                      {label}
                    </div>
                    <div className="aspect-[4/3] flex items-center justify-center text-[#7A8A7A] text-[10px] sm:text-sm text-center px-1">
                      Bild einsetzen
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;
